import React, { useState } from "react";
import Header from "components/Header/Header";
import TextSkeleton from "components/Skeletons/TextSkeleton/TextSkeleton";
import PropTypes from "prop-types";
import useCart from "hooks/useCart";
import { Link } from "react-router-dom";
import { CartIcon, VendingMachineIcon } from "constants/icons";
import { APP_ROUTES } from "constants/routes";
import "containers/Home/HomeHeader/HomeHeader.css";
import { connect, useSelector } from "react-redux";
import SearchBar from "components/SearchBar/SearchBar";
import {SearchIcon} from "../../../constants/icons";

function HomeHeader({ vmName, clDetails,handleSearchBar }) {
  const { cartTotalQuantities } = useCart();
  const [isActive, setIsActive] = useState(false);
  const vendingMachineItems = useSelector((state) => state.vmStockReducer.items);

  return (
    <>
   {!isActive?
     <Header className="homepage__header">
      <div className="homepage__vending-machine-name__wrapper">
        <i>
          <img
            src={clDetails.logo_without_slogan}
            style={{
              marginTop: "-18px",
              width: "100px",
              height: "50px",
            }}
          />
        </i>
      
      </div>
      <div style={{display:"flex", gap:"1rem"}}>
      <div onClick={()=>setIsActive(true)} color="black" className="serachIcon">
       <SearchIcon />
     </div> 
        
      <Link to={APP_ROUTES.CART_PAGE.url}>
        <i>
          <CartIcon />
        </i>
        {cartTotalQuantities !== 0 && (
          <span className="homepage__total-cart-items">
            {cartTotalQuantities}
          </span>
        )}
      </Link>
      </div>
    </Header>
    :
    <div style={{position:"relative", marginInline:"2rem",}}>
    
     <div style={{display:"flex",alignItems:"center",gap:"0.5rem", marginTop:"1rem",position:"absolute", zIndex:"11",width:"100%" }}>
     <SearchBar
        data={vendingMachineItems}
        onChange={handleSearchBar}
        filterKey="name"
        className="searchBar"
      />
      <span style={{color:"black"}} onClick={()=>[setIsActive(false),handleSearchBar(vendingMachineItems)]}>Cancel</span>
      </div>
      </div>
    
  }
  </>
  );
}

HomeHeader.propTypes = {
  vmName: PropTypes.string,
};
const mapStateToProps = (state) => ({
  clDetails: state.clDetailsReducer,
});
const mapDispatchToProps = (dispatch) => ({});
export default connect(mapStateToProps, mapDispatchToProps)(HomeHeader);
